import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
  IWizardContentComponent,
  IValueChangedEvent,
  IComponentStateHistory
} from '../../../wizard.content';
import { CommonRegEx } from '@nrwl/common-lib';
import { REMOVED } from '../../../services/base.wizard.step';

@Component({
  selector: 'nrwl-threshold-server-selection-page',
  templateUrl: './threshold.server.selection.page.component.html',
  styleUrls: ['./threshold.server.selection.page.component.scss']
})
export class ThresholdServerSelectionPageComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  @ViewChild('currentForm') form: NgForm;
  @Input() previousOutput: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  serverIp: string;
  serverSelected = false;
  validAddressRegex: RegExp = CommonRegEx.IP_V4_V6;

  ngOnInit() {
    this.step.form = this.form;
    const serverIpValue = this.stateHistory(this.componentId, 'serverIpInput');
    if (serverIpValue && serverIpValue.value && serverIpValue.value !== REMOVED) {
      this.serverIp = serverIpValue.value;
    }
  }

  enterServerIp(): void {
    if (this.serverIp) {
      this.serverSelected = this.validAddressRegex.test(this.serverIp);
      if (this.serverSelected) {
        this.updateServerThreshold('serverIpInput', 'serverIp', this.serverIp, true);
      } else {
        this.updateServerThreshold('serverIpInput', 'serverIp', REMOVED, false);
      }
    } else {
      this.updateServerThreshold('serverIpInput', 'serverIp', REMOVED, false);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  updateServerThreshold(inputVal: any, key: any, newVal: any, isValid: any): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: inputVal,
      key: key,
      newValue: newVal,
      isValid: isValid
    });
  }
}
